import { render, staticRenderFns } from "./SubresourceExpansionPanel.vue?vue&type=template&id=8ef8a8ea&"
import script from "./SubresourceExpansionPanel.vue?vue&type=script&lang=ts&"
export * from "./SubresourceExpansionPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports